export const appConstants = {
  mobileMaxWidth: 850,
  rightNavItemHeight: 30,
  sideDrawerWidth: 220,
  rightNavWidth: 160,
};

export const lineStyle = { marginLeft: -20, fontSize: 16, color: "gray" };

export const domain = 'https://gifted-charts.web.app/';
// export const domain = 'http://localhost:3000/';
